export function getOrderByFromSort(sortDefs) {
  // Build a sorting array from an array of objects describing sorted fields
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-tasks-support-Query.html#orderByFields
  if (!sortDefs || !sortDefs.length) {
    return null;
  }

  const sorts = sortDefs.map(sortDef => {
    return `${sortDef.id} ${sortDef.desc ? 'desc' : 'asc'}`;
  });

  if (!sorts.length) {
    return null;
  }

  return sorts;
}

export function joinWhereClause(clauses) {
  return clauses
    .filter(clause => clause)
    .map(clause => `(${clause})`)
    .join(' AND ');
}

export function getWhereFromFilters(filters) {
  const wheres = filters.map(filter => {
    switch (filter.type) {
      case 'string':
        return getFreeformFilter(filter.id, filter.value);
      case 'domain':
        return getDomainFilter(filter.id, filter.value);
      case 'date':
      case 'esriFieldTypeDate':
        return getDaterangeFilter(filter.id, filter.value);
      default:
        return getFreeformFilter(filter.id, filter.value);
    }
  });

  if (!wheres.length) {
    return '1=1';
  }

  return wheres.filter(w => w).join(' AND ');
}

//
// Where Clause Builders
//

export function getFreeformFilter(field, value) {
  return `(UPPER(${field}) LIKE UPPER('%${value}%'))`;
}

export function getDomainFilter(field, values) {
  if (!values.length) return null;
  return `${field} IN ('${values.join("','")}')`;
}

export function getDaterangeFilter(field, values) {
  if (!values[0] && !values[1]) return;

  let from;
  let to;
  if (field === 'ModifiedOnDateTime' || field === 'CreatedOnDateTime') {
    from = values[0].unix() * 1000;
    to = values[1].unix() * 1000;
  } else {
    from = `'${values[0].format('YYYY-MM-DD')}'`;
    to = `'${values[1].format('YYYY-MM-DD')}'`;
  }

  return `(${field} > ${from}) AND (${field} < ${to})`;
}



// WEBPACK FOOTER //
// ./src/esri/queryUtils.js